var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "187.000000pt",
    height: "186.000000pt",
    viewBox: "0 0 187.000000 186.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,186.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M337 1503 c-4 -3 -7 -264 -7 -579 0 -512 2 -572 16 -578 29 -11 41 -6 104 44 l62 50 28 -20 c15 -10 33 -26 40 -35 14 -17 63 -45 78 -45 5 0 37 23 71 50 l63 50 63 -50 c34 -27 68 -50 75 -50 7 0 41 23 76 51 l64 51 43 -34 c77 -64 93 -71 119 -57 13 7 44 30 70 52 l47 39 64 -51 c69 -54 100 -63 117 -32 14 26 14 1089 0 1126 -8 21 -16 26 -38 23 l-27 -3 -3 -517 c-1 -285 -6 -518 -10 -518 -5 0 -26 13 -48 30 -21 16 -46 30 -54 30 -8 0 -43 -22 -76 -50 l-62 -49 -63 49 c-35 28 -70 50 -78 50 -7 0 -42 -23 -76 -50 l-64 -51 -33 29 c-49 42 -94 72 -109 72 -7 0 -33 -17 -58 -38 -25 -20 -53 -43 -62 -50 -14 -10 -26 -4 -79 38 -34 27 -69 50 -77 50 -8 0 -35 -16 -59 -36 l-44 -36 0 506 c0 331 -4 514 -10 527 -10 18 -50 26 -63 12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626 1325 c-3 -9 -6 -27 -6 -40 0 -16 -10 -30 -29 -41 -55 -32 -68 -107 -27 -149 13 -13 42 -29 65 -35 56 -15 85 -44 71 -70 -12 -23 -68 -27 -100 -8 -16 10 -23 9 -44 -11 -30 -28 -22 -46 27 -59 25 -6 33 -15 38 -41 13 -65 59 -70 59 -6 0 30 4 37 34 49 57 24 85 106 52 151 -8 11 -43 31 -77 45 -65 26 -82 47 -59 75 14 17 53 20 79 5 14 -7 24 -4 41 16 28 29 19 43 -32 53 -28 6 -34 12 -38 41 -4 26 -10 36 -26 38 -13 2 -24 -4 -28 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M952 1173 c3 -16 21 -18 170 -21 162 -3 217 5 203 29 -4 5 -85 9 -191 9 -171 0 -185 -1 -182 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950 1060 c0 -20 4 -20 188 -18 158 3 187 5 187 18 0 13 -29 15 -187 18 -184 2 -188 2 -188 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M957 963 c-4 -3 -7 -12 -7 -20 0 -10 37 -13 183 -13 101 0 187 3 190 7 4 3 2 12 -4 20 -9 10 -52 13 -184 13 -94 0 -175 -3 -178 -7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBilled);
export default __webpack_public_path__ + "static/media/Billed.cf050e80.svg";
export { ForwardRef as ReactComponent };